import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const OrangeTaskCheckbox = () => (
  <ImageIcon src={Images.OrangeTaskCheckbox} alt="Orange Task Checkbox" />
);

export default OrangeTaskCheckbox;
